/* eslint-disable max-len */
import { Config } from '@leverege/plugin';
import { Attributes } from '@leverege/ui-attributes';
import C from "./Constants.js";
/**
 * Check if the locator's keystream device state shows the device as already been activated.
 */
function isLocatorActivated(locator) {
  const keystreamDeviceState = Attributes.get('locator.keystreamDeviceState', 'locator', locator);
  return keystreamDeviceState === C.KEYSTREAM_ACTIVATED;
}

/**
 * Checks if the locator's last reported heartbeat is within the 'offline' window (3h).
 */
function isLocatorOffline(locator) {
  const locatorOfflineWindow = Config.get('Pairing', 'locatorOfflineWindow', 1000 * 60 * 60 * 3);
  const lastHeartbeat = Attributes.get('locator.lastHeartbeat', 'locator', locator);
  return lastHeartbeat && lastHeartbeat < Date.now() - locatorOfflineWindow;
}

/**
 * Checks if the locator's battery level is below the 'low battery' threshold (70%).
 */
function isLocatorLowBattery(locator) {
  const batteryLevel = Attributes.get('locator.batteryLevel', 'locator', locator);
  return batteryLevel && batteryLevel < 70;
}
export function getPairedVehicleSaleWarningMessage(data, plural = false) {
  const s = plural ? 's' : '';
  const nS = plural ? '' : 's';
  if (data.vehiclesWithTagsAndLocators > 0) {
    return {
      warning: `${plural ? `${data.pairedVehicles.length} vehicles are` : 'A vehicle is'} still paired with a locator${plural ? ' and/or have' : ', and'} at least 1 key${plural ? '' : ' is'} paired to a tag. The vehicle${s} will enter the Sale Pending state.\n\n` + `Unpair and remove the locator${s} from the vehicle${s} and the tag(s) from the key(s) before the vehicle${s} leave${nS} the lot.`,
      pairedTo: C.VEHICLE_PAIRED_TO.TAG_AND_LOCATOR
    };
  }
  if (data.vehiclesWithLocatorsOnly > 0) {
    return {
      warning: `${plural ? `${data.pairedVehicles.length} vehicles are` : 'A vehicle is'} still paired with a locator and will enter the Sale Pending state. Unpair and remove the locator${s} from the vehicle${s} before the vehicle${s} leave${nS} the lot.`,
      pairedTo: C.VEHICLE_PAIRED_TO.LOCATOR
    };
  }
  return {
    warning: `${plural ? `${data.pairedVehicles.length} vehicles have at least 1 key` : "At least 1 of a vehicle's keys is"} paired to a tag. Unpair and remove the tag(s) from the key(s) before the vehicle${s} leave${nS} the lot.`,
    pairedTo: C.VEHICLE_PAIRED_TO.TAG
  };
}

/**
 * Check if the tag's keystream device state shows the device as already been activated by checking if last heartbeat is not null
 * and is within the offline window (10 mins)
 */
function isTagActivated(tag) {
  const tagOfflineWindow = Config.get('Pairing', 'tagOfflineWindow', 1000 * 60 * 10);
  const lastHeartbeat = Attributes.get('tag.lastHeartbeat', 'tag', tag);
  return lastHeartbeat && lastHeartbeat > Date.now() - tagOfflineWindow;
}

/**
 * Checks if the tag's battery level is below the 'low battery' threshold (50%).
 */
function isTagLowBattery(tag) {
  const batteryLevel = Attributes.get('tag.batteryLevel', 'tag', tag);
  return batteryLevel && batteryLevel < 50;
}

/**
 * Check if the locator health alerts is 'gpsInoperative' or contains 'gpsInoperative'.
 */
function isGpsInoperative(locator) {
  const health = Attributes.get('locator.locatorHealth', 'locator', locator);
  return health?.includes('gpsInoperative');
}
export default {
  isLocatorActivated,
  isLocatorOffline,
  isLocatorLowBattery,
  isTagActivated,
  isTagLowBattery,
  isGpsInoperative
};